export enum EvvExceptionSeverityEnum {
  Info = 1,
  Warning = 2,
  Critical = 3
}

export const EvvExceptionSeverityOptions = [
{ id: 1, label: 'Info' },
{ id: 2, label: 'Warning' },
{ id: 3, label: 'Critical' }
];
